module.exports = __webpack_public_path__ + "img/xunjian.40d18152.jpg";